<template>
  <span>
    <!-- -->
    <v-card
      class="d-inline-block"
      style="
        background: white;
        height: 90px;
        width: 240px;
        border-radius: 3px;
        margin: 0px 15px 15px 0px;
      "
      elevation="3"
    >
      <v-row class="fill-height" no-gutters>
        <v-col
          cols="4"
          :style="{ background: color }"
          class="d-flex align-center justify-center"
        >
          <v-icon size="50" dark>{{ icono }}</v-icon>
        </v-col>
        <v-col class="pt-2 pl-3 pr-2 pb-2">
          <div style="text-transform: uppercase" class="caption">
            <slot>Título de la tarjeta</slot>
          </div>
          <div class="title">{{ valor }}</div>
        </v-col>
      </v-row>
    </v-card>
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#00C0EF",
    },
    icono: {
      type: String,
      default: "mdi-gauge",
    },
    titulo: {
      type: String,
      default: "Titulo tarjeta resumen",
    },
    valor: {
      default: "Valor"
    },
  },
  data() {
    return {
    };
  },
  methods: {}
};
</script>

<style>
</style>